import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import cn from 'classnames';

var BtnArrowUp = function BtnArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.529 0a.474.474 0 0 0-.357.137L.137 4.172a.488.488 0 0 0 .69.689L4.53 1.156l3.705 3.705a.488.488 0 0 0 .69-.69L4.89.138A.477.477 0 0 0 4.53 0z"
  }));
};

BtnArrowUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.0618038 4.9977479"
};

var BtnArrowDown = function BtnArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.533 4.997c.13.006.26-.039.357-.136L8.925.826a.488.488 0 0 0-.69-.69L4.532 3.843.826.137a.488.488 0 0 0-.69.69L4.172 4.86c.097.097.23.143.362.136z"
  }));
};

BtnArrowDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.0618038 4.9977479"
};
import Icon from "../Icon";
import createStyles from "../createStyles";
import Button from "../Button";
import Col from "../Layout/Col";
import { blueGray100 } from "../theme/colors";
export var useStyles = createStyles(function (theme) {
  return {
    arrowsContainer: {
      height: '100%',
      flex: '0 0 46px'
    },
    arrow: {
      flexGrow: 1,
      borderRadius: 0,
      fill: theme.palette.secondary["default"],
      transition: theme.transition.create('fill'),
      '&:hover': {
        fill: theme.palette.primary["default"]
      }
    },
    disabled: {
      fill: blueGray100,
      '&:hover': {
        fill: blueGray100
      }
    },
    upArrow: {
      borderLeft: "solid 1px ".concat(theme.palette.border),
      borderBottom: "solid 1px ".concat(theme.palette.border)
    },
    downArrow: {
      borderLeft: "solid 1px ".concat(theme.palette.border)
    }
  };
});

var NumberPickerArrows = function NumberPickerArrows(_ref) {
  var disableDec = _ref.disableDec,
      disableInc = _ref.disableInc,
      onInc = _ref.onInc,
      onDec = _ref.onDec;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Col, {
    className: classes.arrowsContainer,
    "data-qa": "number-picker-arrows"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn(classes.arrow, classes.upArrow, _defineProperty({}, classes.disabled, disableInc)),
    disabled: disableInc,
    type: "button",
    onClick: onInc,
    size: "xs"
  }, /*#__PURE__*/React.createElement(Icon, {
    svg: BtnArrowUp,
    width: 10,
    height: 10
  })), /*#__PURE__*/React.createElement(Button, {
    className: cn(classes.arrow, classes.downArrow, _defineProperty({}, classes.disabled, disableDec)),
    disabled: disableDec,
    type: "button",
    onClick: onDec,
    size: "xs"
  }, /*#__PURE__*/React.createElement(Icon, {
    svg: BtnArrowDown,
    width: 10,
    height: 10
  })));
};

export default NumberPickerArrows;